import React from 'react'
import authRoute from './authRoute'

export const publicRoutes = [...authRoute]

const dashboardOverviewAuthority = ['dashboard.overview.view', 'dashboard.view']
const dashboardSalesPipelineAuthority = [
    'dashboard.sales.view',
    'dashboard.sales_pipeline.view',
    'dashboard.view',
]
const dashboardCandidatePipelineAuthority = [
    'dashboard.candidate_pipeline.view',
    'dashboard.view',
]
const dashboardFinanceAuthority = ['dashboard.finance.view', 'dashboard.view']
const kpiAuthority = ['kpi.assignments.view', 'kpi.read']
const adminUsersAuthority = ['admin.users.view', 'admin.user.manage']
const adminRolesAuthority = ['admin.roles.view', 'admin.role.manage']
const adminLegalEntitiesAuthority = [
    'admin.legal_entities.view',
    'admin.config.manage',
]
const adminOrgChartAuthority = ['admin.org_chart.view', 'admin.config.manage']
const adminConfigsAuthority = ['admin.configs.view', 'admin.config.manage']
const adminDataScopesAuthority = [
    'admin.data_scopes.view',
    'admin.config.manage',
    'admin.role.manage',
]
const adminUserGroupsAuthority = [
    'admin.user_groups.view',
    'admin.user.manage',
]
const adminAuditLogsAuthority = ['admin.audit_logs.view', 'admin.config.manage']
const adminSalesPipelinesAuthority = [
    'admin.sales_pipelines.view',
    'admin.config.manage',
]
const salesAccountsAuthority = ['sales.accounts.view', 'client.read']
const salesContactsAuthority = ['sales.contacts.view', 'client.read']
const salesOpportunitiesAuthority = [
    'sales.opportunities.view',
    'opportunity.read',
]
const salesContractsAuthority = ['sales.contracts.view', 'contract.read']
const headhuntingRequestsAuthority = [
    'services.headhunting_requests.view',
    'headhunting.request.read',
]
const headhuntingApplicantsAuthority = [
    'services.headhunting_applicants.view',
    'headhunting.applicant.read',
]
const headhuntingTalentPoolAuthority = [
    'services.headhunting_talent_pool.view',
    'headhunting.candidate.read',
]
const headhuntingOffersAuthority = [
    'services.headhunting_offers.view',
    'headhunting.offer.read',
]
const financeInvoicesAuthority = ['finance.invoices.view', 'invoice.read']
const financeReceivablesAuthority = ['finance.receivables.view', 'invoice.read']
const financePaymentsAuthority = [
    'finance.payment_tracking.view',
    'invoice.update_payment',
]
const fileImportAuthority = ['file_management.file_import.view', 'client.read']
const templateAuthority = [
    'tools.generate_file_templates.view',
    'template.read',
]
const uploadedTemplatesAuthority = templateAuthority
const fileGenerateAuthority = [
    'tools.generate_file_files.view',
    'template.generate',
]

export const protectedRoutes = [
    {
        key: 'home',
        path: '/home',
        component: React.lazy(() => import('features/home/pages/HomePage')),
        authority: [],
    },
    {
        key: 'dashboard',
        path: '/dashboard',
        component: React.lazy(() =>
            import('features/dashboard/pages/DashboardPage')
        ),
        authority: dashboardOverviewAuthority,
    },
    {
        key: 'dashboard.salesPipeline',
        path: '/dashboard/sales-pipeline',
        component: React.lazy(() =>
            import('features/dashboard/pages/SalesPipelineDashboard')
        ),
        authority: dashboardSalesPipelineAuthority,
    },
    {
        key: 'dashboard.candidatePipeline',
        path: '/dashboard/candidate-pipeline',
        component: React.lazy(() =>
            import('features/dashboard/pages/CandidatePipelineDashboard')
        ),
        authority: dashboardCandidatePipelineAuthority,
    },
    {
        key: 'dashboard.finance',
        path: '/dashboard/finance',
        component: React.lazy(() =>
            import('features/dashboard/pages/FinanceDashboard')
        ),
        authority: dashboardFinanceAuthority,
    },
    {
        key: 'kpi',
        path: '/kpi',
        component: React.lazy(() =>
            import('features/kpi/pages/KpiAssignmentsPage')
        ),
        authority: kpiAuthority,
    },
    {
        key: 'kpi.assignmentDetail',
        path: '/kpi/assignments/:id',
        component: React.lazy(() =>
            import('features/kpi/pages/KpiAssignmentDetailPage')
        ),
        authority: kpiAuthority,
    },
    {
        key: 'dashboard.kpi.legacy',
        path: '/dashboard/kpi',
        component: React.lazy(() =>
            import('features/kpi/pages/KpiAssignmentsPage')
        ),
        authority: kpiAuthority,
    },
    {
        key: 'profile',
        path: '/profile',
        component: React.lazy(() =>
            import('features/user/pages/UserProfilePage')
        ),
        authority: [],
    },
    {
        key: 'notifications',
        path: '/notifications',
        component: React.lazy(() =>
            import('features/common/pages/Notifications')
        ),
        authority: [],
    },
    {
        key: 'accessDenied',
        path: '/access-denied',
        component: React.lazy(() =>
            import('features/auth/pages/AccessDeniedPage')
        ),
        authority: [],
    },
    // Admin routes
    {
        key: 'admin.legalEntities',
        path: '/admin/legal-entities',
        component: React.lazy(() =>
            import('features/admin/pages/LegalEntities')
        ),
        authority: adminLegalEntitiesAuthority,
    },
    {
        key: 'admin.orgChart',
        path: '/admin/org-chart',
        component: React.lazy(() =>
            import('features/admin/pages/OrgChart')
        ),
        authority: adminOrgChartAuthority,
        meta: {
            footer: false,
        },
    },
    {
        key: 'admin.configs',
        path: '/admin/configs',
        component: React.lazy(() =>
            import('features/admin/pages/Configs')
        ),
        authority: adminConfigsAuthority,
    },
    {
        key: 'admin.dataScopes',
        path: '/admin/data-scopes',
        component: React.lazy(() =>
            import('features/admin/pages/DataScopes')
        ),
        authority: adminDataScopesAuthority,
    },
    {
        key: 'admin.userGroups',
        path: '/admin/user-groups',
        component: React.lazy(() =>
            import('features/admin/pages/UserGroups')
        ),
        authority: adminUserGroupsAuthority,
    },
    {
        key: 'admin.roles',
        path: '/admin/roles',
        component: React.lazy(() => import('features/admin/pages/Roles')),
        authority: adminRolesAuthority,
    },
    {
        key: 'admin.auditLogs',
        path: '/admin/audit-logs',
        component: React.lazy(() =>
            import('features/admin/pages/AuditLogs')
        ),
        authority: adminAuditLogsAuthority,
    },
    {
        key: 'admin.salesPipelines',
        path: '/admin/sales-pipelines',
        component: React.lazy(() =>
            import('features/admin/pages/SalesPipelines')
        ),
        authority: adminSalesPipelinesAuthority,
    },
    {
        key: 'admin.userDetail',
        path: '/admin/users/:id',
        component: React.lazy(() =>
            import('features/admin/pages/UserDetail')
        ),
        authority: adminUsersAuthority,
    },
    {
        key: 'admin.users',
        path: '/admin/users',
        component: React.lazy(() => import('features/user/pages/Users')),
        authority: adminUsersAuthority,
    },
    // Sales routes
    {
        key: 'sales.account',
        path: '/sales/accounts',
        component: React.lazy(() =>
            import('features/sales/pages/AccountsPage')
        ),
        authority: salesAccountsAuthority,
    },
    {
        key: 'sales.contact',
        path: '/sales/contacts',
        component: React.lazy(() =>
            import('features/sales/pages/ContactsPage')
        ),
        authority: salesContactsAuthority,
    },
    // CRM routes — design reorganises Client management under /crm.
    // The legacy /sales/accounts and /sales/contacts paths above are
    // retained for backwards compatibility while navigation migrates.
    {
        key: 'crm.clients',
        path: '/crm/clients',
        component: React.lazy(() => import('features/crm/pages/Clients')),
        authority: salesAccountsAuthority,
    },
    {
        key: 'crm.clientDetail',
        path: '/crm/clients/:id',
        component: React.lazy(() =>
            import('features/crm/pages/ClientDetail')
        ),
        authority: salesAccountsAuthority,
    },
    {
        key: 'crm.contacts',
        path: '/crm/contacts',
        component: React.lazy(() =>
            import('features/crm/pages/ContactsPage')
        ),
        authority: salesContactsAuthority,
    },
    {
        key: 'sales.opportunity',
        path: '/sales/opportunities',
        component: React.lazy(() =>
            import('features/sales/pages/OpportunitiesPage')
        ),
        authority: salesOpportunitiesAuthority,
    },
    {
        key: 'sales.pipeline',
        path: '/sales/pipeline',
        component: React.lazy(() =>
            import('features/sales/pages/PipelinePage')
        ),
        authority: salesOpportunitiesAuthority,
    },
    {
        key: 'sales.contract',
        path: '/sales/contracts',
        component: React.lazy(() =>
            import('features/sales/pages/ContractsPage')
        ),
        authority: salesContractsAuthority,
    },
    {
        key: 'sales.contractDetail',
        path: '/sales/contracts/:id',
        component: React.lazy(() =>
            import('features/sales/pages/ContractDetail')
        ),
        authority: salesContractsAuthority,
    },
    // Services / Headhunting routes
    {
        key: 'services.headhunting.requests',
        path: '/services/headhunting/requests',
        component: React.lazy(() =>
            import('features/headhunting/pages/RequestsPage')
        ),
        authority: headhuntingRequestsAuthority,
    },
    {
        key: 'services.headhunting.applicants',
        path: '/services/headhunting/applicants',
        component: React.lazy(() =>
            import('features/headhunting/pages/ApplicantsPage')
        ),
        authority: headhuntingApplicantsAuthority,
    },
    {
        key: 'services.headhunting.pool',
        path: '/services/headhunting/pool',
        component: React.lazy(() =>
            import('features/headhunting/pages/TalentPoolsPage')
        ),
        authority: headhuntingTalentPoolAuthority,
    },
    {
        key: 'services.headhunting.offer',
        path: '/services/headhunting/offer',
        component: React.lazy(() =>
            import('features/headhunting/pages/OffersPage')
        ),
        authority: headhuntingOffersAuthority,
    },
    {
        key: 'headhunting.request.legacy',
        path: '/headhunting/requests',
        component: React.lazy(() =>
            import('features/headhunting/pages/RequestsPage')
        ),
        authority: headhuntingRequestsAuthority,
    },
    {
        key: 'headhunting.applicants.legacy',
        path: '/headhunting/applicants',
        component: React.lazy(() =>
            import('features/headhunting/pages/ApplicantsPage')
        ),
        authority: headhuntingApplicantsAuthority,
    },
    {
        key: 'headhunting.pool.legacy',
        path: '/headhunting/pool',
        component: React.lazy(() =>
            import('features/headhunting/pages/TalentPoolsPage')
        ),
        authority: headhuntingTalentPoolAuthority,
    },
    {
        key: 'headhunting.offer.legacy',
        path: '/headhunting/offer',
        component: React.lazy(() =>
            import('features/headhunting/pages/OffersPage')
        ),
        authority: headhuntingOffersAuthority,
    },
    // Finance routes
    {
        key: 'finance.invoices',
        path: '/finance/invoices',
        component: React.lazy(() =>
            import('features/finance/pages/Invoices')
        ),
        authority: financeInvoicesAuthority,
    },
    {
        key: 'finance.receivables',
        path: '/finance/receivables',
        component: React.lazy(() =>
            import('features/finance/pages/Receivables')
        ),
        authority: financeReceivablesAuthority,
    },
    {
        key: 'finance.payments',
        path: '/finance/payments',
        component: React.lazy(() =>
            import('features/finance/pages/Payments')
        ),
        authority: financePaymentsAuthority,
    },
    {
        key: 'fileManagement.fileImport',
        path: '/file-management/file-import',
        component: React.lazy(() =>
            import('features/file-management/pages/FileImportPage')
        ),
        authority: fileImportAuthority,
    },
    {
        key: 'fileManagement.uploadedTemplates',
        path: '/file-management/uploaded-templates',
        component: React.lazy(() =>
            import('features/file-management/pages/UploadedTemplatesPage')
        ),
        authority: uploadedTemplatesAuthority,
    },
    {
        key: 'tools.templates',
        path: '/tools/templates',
        component: React.lazy(() =>
            import('features/tools/pages/Templates')
        ),
        authority: templateAuthority,
    },
    {
        key: 'tools.fileGenerate.generating',
        path: '/tools/file-generate/generating',
        component: React.lazy(() =>
            import('features/tools/pages/file-generate/GeneratingPage')
        ),
        authority: fileGenerateAuthority,
    },
    {
        key: 'tools.cv-generation-legacy',
        path: '/tools/cv-generation',
        component: React.lazy(() =>
            import('features/tools/pages/file-generate/GeneratingPage')
        ),
        authority: fileGenerateAuthority,
    },
    {
        key: 'tools.jd-generation-legacy',
        path: '/tools/jd-generation',
        component: React.lazy(() =>
            import('features/tools/pages/file-generate/GeneratingPage')
        ),
        authority: fileGenerateAuthority,
    },
]
